import PromotionQueryComponent from "@irati/promotions/apollo/query/PromotionQueryComponent"
import {PromotionType} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import theme from "@irati/ui/src/global/theme"
import Pill from "@irati/ui/src/Pill"
import {Label} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import React from "react"

const SpecialOfferLabel = (props) => (
  <PromotionQueryComponent type={PromotionType.RewardChristmasMerchandise}>
    {({data: {promotionStatus} = {}}) =>
      promotionStatus?.enabled && (
        <Flex {...props}>
          <Pill inline backgroundColor={theme.colors.tertiary.r_200} text={<FormattedMessage id="perks.physicalProduct.offer.badge" />} />

          <Label weight="bold" small marginLeft={theme.spacing.oneAndHalf}>
            <FormattedMessage id="perks.physicalProduct.offer.info" />
          </Label>
        </Flex>
      )
    }
  </PromotionQueryComponent>
)

export default SpecialOfferLabel
